import request from '@/utils/request'

// 查询MBOM清单列表
export function apiMbomBillStructuresList (data) {
  return request({
    url: '/mdm/mbomBillStructures/list',
    method: 'post',
    data: data
  })
}

// 查询MBOM差异明细
export function apiMbomBillStructuresDiffDetail (query) {
  return request({
    url: '/mdm/mbomBillStructures/diff/detail',
    method: 'get',
    params: query
  })
}

// 查询MBOM日志列表
export function apiMbomBillStructuresLogList (query) {
  return request({
    url: '/mdm/mbomBillStructures/log/list',
    method: 'get',
    params: query
  })
}

// MBOM清单升级（包含组件变更）
export function apiMbomBillStructuresEdit (data) {
  return request({
    url: '/mdm/mbomBillStructures/edit',
    method: 'post',
    data: data
  })
}

// PBOM差异处理
export function apiMbomBillStructuresApply (data) {
  return request({
    url: '/mdm/mbomBillStructures/pbomDiff/apply',
    method: 'post',
    data: data
  })
}

// 导出MBOM清单列表
export function apiMbomBillStructuresExport (data) {
  return request({
    url: '/mdm/mbomBillStructures/export',
    method: 'post',
    data: data
  })
}

// 物料获取
export function apiGetBomNewMaterial(query) {
  return request({
    url: '/scp/scpMrpSystemItems/planItemsBoxNew',
    method: 'get',
    params: query
  })
}

// PBOM批量差异处理
export function apiMbomBillStructuresBatchApply (data) {
  return request({
    url: '/mdm/mbomBillStructures/pbomDiff/batchApply',
    method: 'post',
    data: data
  })
}

// 替换物料操作
export function apiBatchModifyMaterial(data) {
  return request({
    url: '/mdm/mbomBillStructures/batchReplaceMaterial',
    method: 'post',
    data: data
  })
}
